export default __webpack_public_path__ + "static/media/workout-tracker.698f0806.png";